import { render, staticRenderFns } from "./WebStoreSuspended.vue?vue&type=template&id=ccac99da&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccac99da",
  null
  
)

export default component.exports